module.exports = __webpack_public_path__ + "static/img/c_crm71.3836b99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c_crm71.png
// module id = Uzq8
// module chunks = 73